/**
 * Searches for a percentage in parentheses from a route split
 * i.e. `"Orca (5%)".split(...) => ["Orca ", "(5%)"];`
 */
export const percentageInParentheses = /(\(\d+%\))/;

export const transactionErrorFromLog =
  /Error Message: (.*)|Error: (.*)|(.*[Ii]nsufficient.*[Ll]amport)|(.*[Ii]nsufficient.*[Ff]und)/gm;

/**
 * Searches the string for something along the lines of "user rejected the request"
 * This appears in different forms based on the wallet used, so needs to be done this way.
 */
export const transactionRejectedByUser = /(user.*(?=reject|cancel))|((?=reject|cancel).*user)/g;

/**
 * Searches for something along the lines of "slippage exceeded"
 */
export const slippageExceeded = /(slippage.*(?=exceed))|((?=exceed).*slippage)/g;

export const insufficientLamports = /(.*insufficient.*(?=lamport))/g;

export const stringIsImageData = /^([./]*)(?=data)/;
